/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clients_Comm_EnabledInputs */

const cs_clients_comm_enabled = /** @type {(inputs: Clients_Comm_EnabledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zapnuto`)
};

const en_clients_comm_enabled = /** @type {(inputs: Clients_Comm_EnabledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`On`)
};

/**
* | output |
* | --- |
* | "On" |
*
* @param {Clients_Comm_EnabledInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const clients_comm_enabled = /** @type {((inputs?: Clients_Comm_EnabledInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clients_Comm_EnabledInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_clients_comm_enabled(inputs)
	return cs_clients_comm_enabled(inputs)
});